import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, of } from 'rxjs';
import { CourseService } from '../../course.service';
import { CourseActions } from './course.actions';
import { CourseFacade } from './course.facade';
import { TaskModalActions } from '../task/task.actions';
import { ApplicationFacade } from '@lyceo/shared/data-access';
import { PlanFacade } from '../plan/plan.facade';
import { isDefined } from '@lyceo/shared/util';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class CourseEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly courseService: CourseService = inject(CourseService);
  private readonly courseFacade: CourseFacade = inject(CourseFacade);
  private readonly applicationFacade: ApplicationFacade =
    inject(ApplicationFacade);
  private readonly planFacade: PlanFacade = inject(PlanFacade);
  private readonly translocoService: TranslocoService =
    inject(TranslocoService);

  public getAll$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TaskModalActions.init),
      filter(() => this.courseFacade.getAll().length === 0),
      map(() => this.planFacade.pupilId()),
      filter(isDefined),
      exhaustMap((pupilId) =>
        this.courseService.getAll(pupilId).pipe(
          map((courses) => CourseActions.getAllSuccess({ courses: courses })),
          catchError((error: Error) =>
            of(CourseActions.getAllFailure({ error })),
          ),
        ),
      ),
    );
  });

  public getAllFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(CourseActions.getAllFailure),
        map(() => {
          this.applicationFacade.showToaster({
            type: 'error',
            message: this.translocoService.translate(
              'plan.toasts.course_loading_error',
            ),
          });
        }),
      );
    },
    { dispatch: false },
  );
}
